module.exports = __webpack_public_path__ + "img/CellCycle-OVCA_10X_TPCP.7d3fe4d7.png";